// src/components/admin/scheduling/clipboardStore.js
const KEY = "TE_ADMIN_SCHED_CLIPBOARD_V1";

export function loadClipboard() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveClipboard(data) {
  try {
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    // ignore
  }
}

export function clearClipboard() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}